import { routerRedux } from 'dva/router';
import { stringify } from 'querystring';
import { postAccountLogin, getLogout } from '@/services/login';
import { setAuthority } from '@/utils/authority';
import { getPageQuery } from '@/utils/utils';
const Model = {
  namespace: 'login',
  state: {
    status: undefined,
  },
  effects: {
    *login({ payload }, { call, put }) {
      const response = yield call(postAccountLogin, payload);
      yield put({
        type: 'changeLoginStatus',
        payload: response,
      }); // Login successfully

      yield put({
        type: 'user/fetchCurrent',
      });

      if (response.status === 'ok') {
        const urlParams = new URL(window.location.href);
        const params = getPageQuery();
        let { redirect } = params;


        let redirectUrl = sessionStorage.getItem('loginRedirect');
        if(redirectUrl){
          console.log('redirectUrl', redirectUrl);
          console.log('redirectUrl2', redirect, sessionStorage.getItem('loginRedirect'));          
          sessionStorage.removeItem('loginRedirect');
          yield put(routerRedux.replace(redirectUrl || '/'));
          return;       
        }

        if (redirect) {
          const redirectUrlParams = new URL(redirect);

          if (redirectUrlParams.origin === urlParams.origin) {
            redirect = redirect.substr(urlParams.origin.length);

            if (redirect.match(/^\/.*#/)) {
              redirect = redirect.substr(redirect.indexOf('#') + 1);
            }
          } else {
            window.location.href = redirect;
            return;
          }
        }

        yield put(routerRedux.replace(redirect || '/'));
      }
    },

    *logout(_, { call, put }) {
      const { redirect } = getPageQuery(); // redirect
      const response = yield call(getLogout);
      if (window.location.pathname !== '/user/login' && !redirect) {
        yield put(
          routerRedux.replace({
            pathname: '/user/login',
            search: stringify({
              redirect: window.location.href,
            }),
          }),
        );
      }
    },
  },
  reducers: {
    changeLoginStatus(state, { payload }) {
      console.log('changeLoginStatus', payload)
      setAuthority(payload.currentAuthority);
      return { ...state, status: payload.status, type: payload.type };
    },
  },
};
export default Model;
